export const defaultBaseColor = "#ed7d31";
